import { Injectable } from "@angular/core";

@Injectable()
export abstract class ServiceMessageBrokerRegistry {
  abstract registerServiceMessageBroker(channel: string, port: MessagePort): void;
  abstract registerClientMessageBroker(channel: string, port: MessagePort): void;
}
